import React from 'react';

export const IconFlagRU = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <g clipPath="url(#clip0_5205_65265)">
            <path
                d="M0 6.375H24V17.625H0V6.375Z"
                fill="#0052B4"
            />
            <path
                d="M0 16.125H24V24H0V16.125Z"
                fill="#D80027"
            />
            <path
                d="M0 0H24V7.875H0V0Z"
                fill="#EEEEEE"
            />
        </g>
        <defs>
            <clipPath id="clip0_5205_65265">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export const IconFlagEN = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <g clipPath="url(#clip0_5205_65259)">
            <path
                d="M0 0H24V24H0V0Z"
                fill="#0052B4"
            />
            <path
                d="M21.75 24H24V21.75L14.25 12L24 2.25V0H21.75L12 9.75L2.25 0H0V2.25L9.75 12L0 21.75V24H2.25L12 14.25L21.75 24Z"
                fill="#EEEEEE"
            />
            <path
                d="M24 15V9H15V0H9V9H0V15H9V24H15V15H24Z"
                fill="#EEEEEE"
            />
            <path
                d="M24 13.5V10.5H13.5V0H10.5V10.5H0V13.5H10.5V24H13.5V13.5H24Z"
                fill="#D80027"
            />
            <path
                d="M0 1.5V0L9 9H7.5L0 1.5ZM24 22.5V24L15 15H16.5L24 22.5ZM1.5 24H0L9 15V16.5L1.5 24ZM22.5 0H24L15 9V7.5L22.5 0Z"
                fill="#D80027"
            />
        </g>
        <defs>
            <clipPath id="clip0_5205_65259">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export const IconFlagCN = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <g clipPath="url(#clip0_5205_65269)">
            <path
                d="M0 0H24V24H0V0Z"
                fill="#D80027"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1656 6.6373L14.2594 5.38574L13.4484 6.34668L12.2812 5.87324L12.9469 6.9373L12.1359 7.89824L13.3594 7.59824L14.0203 8.66699L14.1094 7.41074L15.3328 7.11074L14.1656 6.6373ZM6.56719 7.30293L7.60312 10.4904H10.9547L8.24531 12.4639L9.28125 15.6514L6.56719 13.6826L3.85312 15.6514L4.89375 12.4639L2.17969 10.4904H5.53125L6.56719 7.30293ZM14.2266 18.5857L13.4344 17.6107L12.2625 18.0654L12.9422 17.0107L12.15 16.0311L13.3641 16.3545L14.0484 15.2998L14.1141 16.5561L15.3328 16.8795L14.1562 17.3295L14.2266 18.5857ZM16.1766 14.5264L15.8016 15.7264L16.8094 14.9717L17.8359 15.6982L17.4328 14.5076L18.4406 13.7576L17.1844 13.7717L16.7766 12.5811L16.4062 13.7811L15.15 13.7998L16.1766 14.5264ZM17.925 8.80762L17.3719 9.9373L18.2719 10.8139L17.0297 10.6357L16.4766 11.7607L16.2609 10.5232L15.0141 10.3451L16.1297 9.75918L15.9141 8.51699L16.8141 9.39355L17.925 8.80762Z"
                fill="#FFDA44"
            />
        </g>
        <defs>
            <clipPath id="clip0_5205_65269">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
